---
de:
  feature_requests:
    categories:
      api_developer: API/Entwickler
      feedback: Feedback
      new_feature: Neue Funktion
    create_request: Anfrage erstellen
    delete: Löschen
    edit_request: Anfrage bearbeiten
    filter_category: Nach Kategorie filtern
    filter_status: Nach Status filtern
    mail_support: E-Mail an den Support
    model_name: Feature-Anfrage
    only_admins_can_delete: Nur Administratoren können Feature-Anfragen löschen
    plural: Feature-Anfragen
    publish: Erstellen
    save: Speichern
    statuses:
      coming_soon: Bald verfügbar
      investigating: Untersucht
      launched: Gestartet
      new: Neu
      not_planned: Nicht geplant
